import { dateFormatter } from '../../../utils/DateFormatter'
import {
  LotFilenameTemplateItem,
  MaterialRequirementFilenameTemplateItem,
  MaterialSourceFilenameTemplateItem,
} from '../classes/density'
import { defaultsTo } from '../utils'

export const DensityLotDate = new LotFilenameTemplateItem({
  id: '8fabf850-dc51-469f-83ee-082382ece4b1',
  name: 'Lot Date',
  property: 'dateLotCreated',
  help: `Uses the earliest Test Date of any associated Density Tests. ${defaultsTo(
    { name: 'Test Date', property: 'Lot Date' }
  )}. ${defaultsTo({
    name: 'Lot Date',
    property: 'Created Date',
  })}`,
  exampleValue: () => dateFormatter(null).file(new Date()),
})

export const DensityLotId = new LotFilenameTemplateItem({
  id: 'b441e271-0729-4f7a-8419-61af27ac29cb',
  name: 'Lot ID',
  property: 'lotId',
  help: 'Lot ID from Lot table',
  exampleValue: 'PLA-0014',
})

export const DensityLotMaterialSource = new MaterialSourceFilenameTemplateItem({
  id: '537af709-2f8a-4352-a6e2-e45acfb22c9a',
  name: 'Material Source',
  property: 'source',
  help: 'Source from Material Source table',
  exampleValue: '2 inch Borrow - Weber Pit',
})

export const DensityLotClassification = new MaterialSourceFilenameTemplateItem({
  id: '251a19d8-37b3-412d-a60c-a36ebdab2cb3',
  name: 'Classification',
  property: 'classification',
  help: 'Classification from Material Source table',
  exampleValue: 'A-1-a',
})

export const DensityLotMaterialSection =
  new MaterialRequirementFilenameTemplateItem({
    id: '260407e3-f257-4428-a27e-ea6b19cba987',
    name: 'Material Section/Requirements',
    property: 'materialSection',
    help: 'Material Section from Material Requirements table',
    exampleValue: 'Granular Backfill Borrow',
  })

export const DensityLotShortName = new MaterialRequirementFilenameTemplateItem({
  id: 'e46f0c20-8657-43c2-b06b-18d06eb5c59f',
  name: 'Material Section/Requirements Short Name',
  property: 'shortName',
  help: 'PDF Naming Convention Name (Short Name) from Material Requirements table',
  exampleValue: 'GBB',
})

export type DensityFilename =
  | typeof DensityLotDate
  | typeof DensityLotId
  | typeof DensityLotMaterialSource
  | typeof DensityLotClassification
  | typeof DensityLotMaterialSection
  | typeof DensityLotShortName
